// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__QuRYY","inputWrap":"styles_inputWrap__3IivC","input":"styles_input__2adVR"};